<immo-menu
  [actions]="profileActions()"
  [triggerAriaLabel]="'Profilmenü für ' + user()?.fullName"
  [triggerClass]="triggerClass()"
  [positions]="positions()"
  (actionSelected)="onAction($event)"
>
  @if (!IsNullOrUndefinedOrEmpty(avatarUrl())) {
    <immo-image
      class="avatar"
      [src]="avatarUrl()!"
      [alt]="user()?.fullName ?? 'user'"
      fit="cover"
    />
  } @else {
    <mat-icon [svgIcon]="ICON.userCircle" aria-hidden="true" />
  }

  <!-- Optional trigger extra (e.g. the user's name in the sidebar row) -->
  <ng-content select="[immoProfileMenuTrigger]" />

  <ng-template immoMenuHeader>
    <ng-content select="immo-profile-menu-header" />
  </ng-template>
</immo-menu>
